import { ShipperCargoDetailPage } from "@/pages/shipper-cargo-detail";
import { createFileRoute, useParams } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth_requeired/shipper/cargos/$cargoId/",
)({
  component: () => {
    const { cargoId: cargoIdStr } = useParams({
      from: "/_auth_requeired/shipper/cargos/$cargoId/",
    });
    return <ShipperCargoDetailPage cargoIdStr={cargoIdStr} />;
  },
});
